export const CN_SPECIAL = 1;
export const GLOBAL_FLEX = 2;

export function getOtherInfo(user = {}) {
  const { other_info: otherInfo } = user;
  if (!otherInfo) return {};
  if (typeof otherInfo === "string") {
    try {
      return JSON.parse(otherInfo);
    } catch (e) {
      return {};
    }
  }
  return otherInfo;
}

export function getAuthStrategy(user = {}) {
  const otherInfo = getOtherInfo(user);
  const value =
    user.auth_strategy !== undefined ? user.auth_strategy : otherInfo.auth_strategy;
  return Number(value) === GLOBAL_FLEX ? GLOBAL_FLEX : CN_SPECIAL;
}

export function hasEmailIdentifier(user = {}) {
  const otherInfo = getOtherInfo(user);
  return Boolean(user.email || user.is_email_bind || otherInfo.is_email_bind);
}

export function shouldForceBindPhone(user = {}) {
  if (getAuthStrategy(user) === GLOBAL_FLEX) {
    return !(user.phone || hasEmailIdentifier(user));
  }
  return !user.phone;
}

export function shouldForceBindWx(user = {}) {
  if (getAuthStrategy(user) === GLOBAL_FLEX) {
    return false;
  }
  return !user.wx_unionid || user.wx_unionid === "(NULL)";
}
